import { render, staticRenderFns } from "./ClientRelease.vue?vue&type=template&id=fd1a181c&scoped=true&"
import script from "./ClientRelease.vue?vue&type=script&lang=js&"
export * from "./ClientRelease.vue?vue&type=script&lang=js&"
import style0 from "./ClientRelease.vue?vue&type=style&index=0&id=fd1a181c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1a181c",
  null
  
)

export default component.exports